import React, { useState, useContext, useEffect, useReducer } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Dialog, makeStyles } from "@material-ui/core";
import { Popover } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { Box } from "@material-ui/core";
import MaterialTable from "material-table";
// import tableReducer, { INITIAL_TABLE_STATE } from "reducers/table_reducer";
import tableIcons, {
    options,
} from "components/universal/table_attributes";
// import TableAction from "actions/table_actions";
import AtasDialog from "./AtasDialog";
// import { ToastMessageContext } from "lib/contexts/message_context";
import { RecencyComplianceServices } from "lib/services/api/compliance/recency_compliance";
import { format24HrDateOnly } from "lib/utils/common_utils";
import BoxpTableAction from "actions/boxp_table_actions";
import TableAction from "actions/table_actions";
import tableReducer, { INITIAL_TABLE_STATE } from "reducers/table_reducer";

const StyledMenu = withStyles({
    paper: {
        width: "523px",
        height: "fit-content",
        top: "290px !important",
        padding: "30px",
        boxShadow: "0px 3px 6px #00000029",
    },
})((props) => (
    <Popover
        elevation={0}
        // getContentAnchorEl={null}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "center",
        }}
        {...props}
    />
));

export default function AtasCovered(props) {
    const { open, handleClose, currentSelection } = props;
    const classes = useStyles();
    // const message = useContext(ToastMessageContext)
    const [loading, setLoading] = useState(false)
    // const [page, setPage] = useState(1);
    // const [pageSize, setPageSize] = useState(10);
    const [ataData, setAtaData] = useState([]);
    const [tableState, dispatch] = useReducer(tableReducer, INITIAL_TABLE_STATE);
    const { page, totalCount, pageSize } = tableState;

    useEffect(() => {
        getList()
    }, [page, pageSize])

    const getList = () => {
        const params = {
            user_id: currentSelection?.user_id,
            type_ids: currentSelection?.type_ids,
            page:  page + 1,
            limit: pageSize
        }
        setLoading(true)
        RecencyComplianceServices.getRecencyPopup(params).then((res) => {
            if (res.success) {
                TableAction.setTotalCount(dispatch, res.total_count);
                // setTotalCount(res.total_count)
                setAtaData(res?.data)
                setLoading(false)
                console.log("console")
            }
        }).catch(() => {
            setLoading(false)
            console.log("console")
        })
    }


    // tableOptions
    const tableOptions = {
        ...options,
        page: page,
        total: totalCount,
        pageSize: pageSize,
        search: false,
        toolbar: false,
        headerStyle: {
            textAlign: "center",
            paddingTop: "22px",
            paddingBottom: "16px",
        },
    };

    const columns = [
        {
            title: "ATA",
            field: "chapter_number",
        },
        {
            title: "Title",
            field: "title",
            headerStyle: {
                width: "60%",
                textAlign: "left"
            },
            cellStyle: {
                width: "60%",
                textAlign: "left"
            }
        },
        {
            title: "Worked",
            field: "updated_at",
            render: (rowData) => format24HrDateOnly(rowData?.updated_at)
        },
    ];

    return (
        <div style={{ position: "relative" }}>
            <AtasDialog
                open={open}
                handleClose={handleClose}
                width="481px"
                notShowButton={true}
            >
                <Box
                    width="100%"
                    mb="30px"
                    ml="0px"
                >
                    <Typography color="primary" className={classes.bodyText}>
                        ATAs covered
                    </Typography>
                </Box>

                <Box width="100%">
                    <MaterialTable
                        style={{ boxShadow: "0px 1px 3px #00000033" }}
                        icons={tableIcons}
                        columns={columns}
                        data={ataData || []}
                        options={tableOptions}
                        localization={{
                            toolbar: {
                                searchPlaceholder: "Search anything",
                            },
                            body: {
                                emptyDataSourceMessage: "No data Found",
                                filterRow: {
                                    filterTooltip: "Filter",
                                },
                            },
                        }}
                        isLoading={loading}
                        page={page}
                        onChangePage={(page) => {
                            TableAction.setPage(dispatch, page);
                        }}
                        onChangeRowsPerPage={(pageSize) => {
                            TableAction.setPageSize(dispatch, pageSize);
                        }}
                        totalCount={totalCount}
                    />
                </Box>
            </AtasDialog>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    bodyText: {
        fontSize: 20,
        lineHeight: "28px",
    },
}));
